// Alle Oberflaechentexte der Seite auf Deutsch und Englisch. Schluessel mit "seite."/"nav."/
// "hero."/"kontakt." gehoeren zum statischen HTML in public/index.html (data-i18n-Attribute),
// die uebrigen zu den React-Komponenten. Projekte, Downloads und Skill-Details tragen ihre
// Uebersetzungen direkt in den Daten (Projects.jsx, Downloads.jsx, mySkills.json).

const texte = {
  de: {
    'seite.titel': 'Wadim Kalakutok | Portfolio',
    'seite.beschreibung': 'Portfolio von Wadim Kalakutok – Fachinformatiker für Systemintegration & Webentwickler.',

    'nav.umschalten': 'Navigation umschalten',
    'nav.start': 'Start',
    'nav.kompetenzen': 'Kompetenzen',
    'nav.projekte': 'Projekte',
    'nav.downloads': 'Downloads',
    'nav.kontakt': 'Kontakt',
    'nav.sprache': 'Switch to English',

    'hero.abzeichen': 'Systemintegration & Moderne Webtechnologien',
    'hero.name': 'Hi, ich bin Wadim',
    'hero.beruf': 'Fachinformatiker für Systemintegration in der Ausbildung mit praktischer Expertise in Webentwicklung, Cloud-Diensten und moderner Netzwerkinfrastruktur.',
    'hero.faehigkeiten': 'Fähigkeiten ansehen',
    'hero.projekte': 'Projekte entdecken',

    'kontakt.titel': 'Kontakt & Vernetzung',
    'kontakt.untertitel': 'Interesse an einer Zusammenarbeit oder Fragen? Schreiben Sie mir gern direkt!',
    'kontakt.telefon': 'Telefon anrufen',
    'kontakt.mail': 'E-Mail senden',
    'kontakt.whatsapp': 'WhatsApp Chat',
    'kontakt.linkedin': 'LinkedIn Profil',
    'kontakt.telegram': 'Telegram Nachricht',
    'kontakt.datenschutz': 'Datenschutz',

    'skills.titel': 'Meine Skills & Kompetenzen',
    'skills.untertitel': 'Eine Übersicht über meine technischen Werkzeuge, Programmiersprachen und Systemkenntnisse',
    'skills.legendeErfahrungHinweis': 'Mehrjährige oder vertiefte praktische Projekterfahrung',
    'skills.legendeErfahrung': 'Praktische Erfahrung',
    'skills.legendeWissenHinweis': 'Solide theoretische und praktische Grundlagen',
    'skills.legendeWissen': 'Allgemeines Wissen',
    'skills.legendeZertifikatHinweis': 'Durch anerkannte Prüfungen und Zertifikate nachgewiesen',
    'skills.legendeZertifikat': 'Zertifizierte Kenntnisse',
    'skills.tabAlle': 'Alle Kompetenzen',
    'skills.tabEntwicklung': 'Web & Entwicklung',
    'skills.tabAdministration': 'IT & Systemadministration',
    'skills.kategorieEntwicklung': 'Webentwicklung & Moderne Frameworks',
    'skills.kategorieAdministration': 'Systemadministration & Netzwerkinfrastruktur',
    'skills.technologien': 'Technologien',

    'skill.kartenHinweis': 'Klicken für detaillierte Informationen',
    'skill.erfahrungVorhanden': 'Praktische Erfahrung vorhanden',
    'skill.wissenVorhanden': 'Allgemeines Wissen vorhanden',
    'skill.erfahrung': 'Praktische Erfahrung',
    'skill.wissen': 'Allgemeines Wissen',
    'skill.zertifikatVorhanden': 'Zertifikat vorhanden',
    'skill.zertifikat': 'Zertifikat',
    'skill.details': 'Details ansehen →',

    'popup.schliessen': 'Modal schließen',
    'popup.keineDaten': 'Keine spezifischen Details für diese Technologie hinterlegt.',

    'projekte.titel': 'Ausgewählte Projekte',
    'projekte.untertitel': 'Eine Auswahl meiner Webanwendungen, Spiele und praktischen Entwicklungsarbeiten',
    'projekte.vorschau': 'Vorschau von',
    'projekte.github': 'Quellcode auf GitHub ansehen',
    'projekte.neuerTab': 'Projekt im neuen Tab öffnen',
    'projekte.schliessen': 'Schließen',

    'downloads.titel': 'Zertifikate & Dokumente',
    'downloads.untertitel': 'Offizielle Nachweise meiner Qualifikationen, Abschlüsse und beruflichen Erfahrungen',
    'downloads.ansehen': 'als PDF ansehen',

    'chat.begruessung': 'Hallo! Ich bin Wadims digitaler KI-Zwilling. Stellen Sie mir gern Fragen zu seinen IT-Kenntnissen, Web-Projekten oder Erfahrungen!',
    'chat.verbindungsfehler': 'Entschuldigung, es gab ein Verbindungsproblem. Bitte versuchen Sie es erneut.',
    'chat.fenster': 'KI Chat-Assistent',
    'chat.titel': 'KI-Zwilling (Wadim)',
    'chat.schliessen': 'Chat schließen',
    'chat.platzhalter': 'Frage zu Kenntnissen, Projekten...',
    'chat.eingabe': 'Nachricht an KI-Assistenten',
    'chat.senden': 'Nachricht senden',
    'chat.hinweisAusblenden': 'Hinweis ausblenden',
    'chat.tooltipTitel': 'KI-Assistent bereit',
    'chat.tooltipVor': 'Fragen Sie meinen ',
    'chat.tooltipZwilling': 'digitalen Zwilling',
    'chat.tooltipNach': ' direkt nach Skills & Erfahrungen.',
    'chat.oeffnen': 'KI-Chat öffnen',
    'chat.oeffnenHinweis': 'Mit Wadims virtuellem Assistenten chatten',
  },

  en: {
    'seite.titel': 'Wadim Kalakutok | Portfolio',
    'seite.beschreibung': 'Portfolio of Wadim Kalakutok – IT specialist for system integration & web developer.',

    'nav.umschalten': 'Toggle navigation',
    'nav.start': 'Home',
    'nav.kompetenzen': 'Skills',
    'nav.projekte': 'Projects',
    'nav.downloads': 'Downloads',
    'nav.kontakt': 'Contact',
    'nav.sprache': 'Auf Deutsch umschalten',

    'hero.abzeichen': 'System Integration & Modern Web Technologies',
    'hero.name': 'Hi, I\'m Wadim',
    'hero.beruf': 'IT specialist for system integration in training, with hands-on expertise in web development, cloud services and modern network infrastructure.',
    'hero.faehigkeiten': 'View skills',
    'hero.projekte': 'Explore projects',

    'kontakt.titel': 'Contact & Networking',
    'kontakt.untertitel': 'Interested in working together or have a question? Feel free to reach out directly!',
    'kontakt.telefon': 'Call by phone',
    'kontakt.mail': 'Send an email',
    'kontakt.whatsapp': 'WhatsApp chat',
    'kontakt.linkedin': 'LinkedIn profile',
    'kontakt.telegram': 'Telegram message',
    'kontakt.datenschutz': 'Privacy Policy',

    'skills.titel': 'My Skills & Expertise',
    'skills.untertitel': 'An overview of my technical tools, programming languages and systems knowledge',
    'skills.legendeErfahrungHinweis': 'Several years or in-depth hands-on project experience',
    'skills.legendeErfahrung': 'Hands-on experience',
    'skills.legendeWissenHinweis': 'Solid theoretical and practical foundations',
    'skills.legendeWissen': 'General knowledge',
    'skills.legendeZertifikatHinweis': 'Proven by recognised exams and certificates',
    'skills.legendeZertifikat': 'Certified skills',
    'skills.tabAlle': 'All skills',
    'skills.tabEntwicklung': 'Web & Development',
    'skills.tabAdministration': 'IT & System Administration',
    'skills.kategorieEntwicklung': 'Web Development & Modern Frameworks',
    'skills.kategorieAdministration': 'System Administration & Network Infrastructure',
    'skills.technologien': 'technologies',

    'skill.kartenHinweis': 'Click for detailed information',
    'skill.erfahrungVorhanden': 'Hands-on experience',
    'skill.wissenVorhanden': 'General knowledge',
    'skill.erfahrung': 'Hands-on experience',
    'skill.wissen': 'General knowledge',
    'skill.zertifikatVorhanden': 'Certificate available',
    'skill.zertifikat': 'Certificate',
    'skill.details': 'View details →',

    'popup.schliessen': 'Close dialog',
    'popup.keineDaten': 'No specific details available for this technology.',

    'projekte.titel': 'Selected Projects',
    'projekte.untertitel': 'A selection of my web applications, games and hands-on development work',
    'projekte.vorschau': 'Preview of',
    'projekte.github': 'View source code on GitHub',
    'projekte.neuerTab': 'Open project in a new tab',
    'projekte.schliessen': 'Close',

    'downloads.titel': 'Certificates & Documents',
    'downloads.untertitel': 'Official proof of my qualifications, degrees and professional experience',
    'downloads.ansehen': '– view as PDF',

    'chat.begruessung': 'Hello! I\'m Wadim\'s digital AI twin. Feel free to ask me about his IT skills, web projects or experience!',
    'chat.verbindungsfehler': 'Sorry, there was a connection problem. Please try again.',
    'chat.fenster': 'AI chat assistant',
    'chat.titel': 'AI Twin (Wadim)',
    'chat.schliessen': 'Close chat',
    'chat.platzhalter': 'Ask about skills, projects...',
    'chat.eingabe': 'Message to the AI assistant',
    'chat.senden': 'Send message',
    'chat.hinweisAusblenden': 'Hide hint',
    'chat.tooltipTitel': 'AI assistant ready',
    'chat.tooltipVor': 'Ask my ',
    'chat.tooltipZwilling': 'digital twin',
    'chat.tooltipNach': ' directly about skills & experience.',
    'chat.oeffnen': 'Open AI chat',
    'chat.oeffnenHinweis': 'Chat with Wadim\'s virtual assistant',
  },
};

export default texte;
